export default __webpack_public_path__ + "static/media/icon-twitter.db4f5b0c.svg";